import { render, staticRenderFns } from "./BadAddressValidationStatus.vue?vue&type=template&id=1f067a2b&"
import script from "./BadAddressValidationStatus.vue?vue&type=script&lang=js&"
export * from "./BadAddressValidationStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports